import { render, staticRenderFns } from "./classification_standards_item.vue?vue&type=template&id=f271a8d0&scoped=true&"
import script from "./classification_standards_item.vue?vue&type=script&lang=js&"
export * from "./classification_standards_item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f271a8d0",
  null
  
)

export default component.exports